import React from 'react';
import Icon from './Icon';
import Button from './Button';
import Modal from './Modal';
import './ui.css';

const SuccessModal = ({ open, onClose, title = 'Sucesso', message, buttonLabel = 'OK' }) => (
  <Modal
    open={open}
    onClose={onClose}
    footer={<Button variant="primary" block onClick={onClose}>{buttonLabel}</Button>}
  >
    <div className="pn-modal__body--center">
      <div className="pn-modal__icon pn-modal__icon--success">
        <Icon name="check-circle" size={50} />
      </div>
      <h2 className="pn-modal__heading pn-modal__heading--success">{title}</h2>
      {message ? <p className="pn-modal__subtitle">{message}</p> : null}
    </div>
  </Modal>
);

export default SuccessModal;
